const TOKEN_PATTERN = /^MHF2026-[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function normalizeQrCredential(value = "") {
  let credential = value.trim();
  if (/^https?:\/\//i.test(credential)) {
    try {
      credential = new URL(credential).searchParams.get("qr") || credential;
    } catch {
      // Keep the original value so validation can return a useful message.
    }
  }
  return credential.replace(/^QR#/i, "").trim();
}

export function isMegaHealthFairQrCredential(value = "") {
  return TOKEN_PATTERN.test(normalizeQrCredential(value));
}
